// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import assetHolderEntity from './entities/asset-holder.json';
import assetHolderMenu from '../pages/asset-holder/menu.json';
import assetHolderFullForm from '../pages/asset-holder/forms/full.json';
import assetHolderContextForm from '../pages/asset-holder/forms/context.json';
import assetHolderMiniForm from '../pages/asset-holder/forms/mini.json';
import assetHolderLookupForm from '../pages/asset-holder/forms/lookup.json';
import assetHolderTableView from '../pages/asset-holder/views/table.json';
import assetHolderCardsView from '../pages/asset-holder/views/cards.json';
import assetHolderCalendarView from '../pages/asset-holder/views/calendar.json';
import assetHolderDashboardView from '../pages/asset-holder/views/dashboard.json';

/** Тип запису «Користувач майна» зі сторінками пакета: меню, форми та подання з pages/asset-holder/. */
export const assetHolderDefinition: IRecordTypeDefinition = {
  ...assetHolderEntity,
  views: assembleViewSet({
      table: assetHolderTableView,
      cards: assetHolderCardsView,
      calendar: assetHolderCalendarView,
      dashboard: assetHolderDashboardView,
  }),
  form: assetHolderFullForm,
  forms: { full: assetHolderFullForm, context: assetHolderContextForm, mini: assetHolderMiniForm, lookup: assetHolderLookupForm },
  menu: assetHolderMenu,
} as IRecordTypeDefinition;
